import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Intro } from "./components/Intro";
import { Portfolio } from "./components/Portfolio";
import { Skills } from "./components/Skills";

function App() {
  const [section, setSection] = useState<"intro" | "portfolio" | "skills">(
    "intro"
  );

  return (
    <div className="relative w-full h-full">
      <AnimatePresence mode="wait">
        {section === "intro" && (
          <motion.div
            key="intro"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5 }}
            className="absolute w-full h-full"
          >
            <Intro onNavigate={setSection} />
          </motion.div>
        )}

        {section === "portfolio" && (
          <motion.div
            key="portfolio"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
            className="absolute w-full h-full"
          >
            <Portfolio onBack={() => setSection("intro")} />
          </motion.div>
        )}

        {section === "skills" && <Skills onBack={() => setSection("intro")} />}
      </AnimatePresence>
    </div>
  );
}

export default App;
